import * as React from "react";
import { styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import {
  MaleFemaleAvatar,
  MaleFemaleIcon,
} from "../patientChart/PatientCaseContainer";
import { CondensedTypographyMedium } from "fe-web-components/styles/typography";
import { MobileView } from "../../../util/aKaunGeneralUtil";

//region [[ Styles ]]
const GenderButtonBoxView = styled("div")(
  ({
    theme,
    "data-selected": selected,
  }: {
    theme?: any;
    "data-selected"?: boolean;
  }) => ({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    width: "170px",
    height: "75px",
    paddingRight: "9px",
    [theme.breakpoints.down(MobileView)]: {
      width: "120px",
      height: "120px",
      marginLeft: "unset",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "10px",
    },
    backgroundColor: "white",
    border:
      selected === true
        ? "2px solid " + KahunColorMap.Primary
        : "2px solid rgb(218, 220, 224)",

    boxShadow: "rgba(0, 0, 0, 0.07) 0px 4px 5px 1px",
    margin: "15px",
    marginLeft: "0px",
  }),
);
const MaleFemaleContainer = styled("div")({
  width: "64px",
  height: "64px",
  marginLeft: "17px",
  marginBottom: "10px",
});

const GenderLabel = styled(CondensedTypographyMedium)(
  ({
    theme,
    "data-selected": selected,
  }: {
    theme?: any;
    "data-selected"?: boolean;
  }) => ({
    fontSize: "21.6px",
    [theme.breakpoints.down(MobileView)]: {
      fontSize: "18px",
    },

    color: selected === true ? KahunColorMap.Primary : KahunColorMap.Default,
  }),
);
//endregion [[ Styles ]]

//region [[ Props ]]
export interface GenderButtonBoxProps {
  className?: string;
  selected: boolean;
  onClick: () => void;
  src: string;
  height?: string;
  text: string;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
/***
 * Small view component to display a gender box button
 * @param props
 * @constructor
 */
export const Gender = ({ ...props }: GenderButtonBoxProps) => (
  <GenderButtonBoxView
    className={props.className}
    data-selected={props.selected}
    onClick={props.onClick}
  >
    <MaleFemaleContainer>
      <MaleFemaleAvatar>
        <MaleFemaleIcon src={props.src} height={props.height || "53"} />
      </MaleFemaleAvatar>
    </MaleFemaleContainer>
    <GenderLabel data-selected={props.selected}>{props.text}</GenderLabel>
  </GenderButtonBoxView>
);
